(() => {
  const reader = document.querySelector('[data-pp-policy="true"]');
  const toc = document.querySelector('[data-pp-toc]');
  if (reader && toc) {
    reader.querySelectorAll('p').forEach(p => {
      const text = p.textContent.trim();
      const strong = p.querySelector('strong');
      if (strong && text.length > 2 && text.length < 120 && strong.textContent.trim() === text) {
        const heading = document.createElement('h2');
        heading.textContent = text.replace(/:\s*$/, '');
        p.replaceWith(heading);
      }
    });
    const headings = [...reader.querySelectorAll('h2, h3')];
    headings.forEach((heading, i) => {
      if (!heading.id) heading.id = 'policy-section-' + (i + 1);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + heading.id;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);
      toc.querySelector('ul').appendChild(li);
    });
    if (headings.length) toc.hidden = false;
  }
})();
